import { useEffect, useRef } from "react";

/**
 * Asked in the page, never by the browser, when leaving a conversation would discard an unsaved
 * edit. Staying is the safe answer, so it holds the focus and Escape means it.
 */
export function LeaveConfirm({ onLeave, onStay }: { onLeave: () => void; onStay: () => void }) {
  const stay = useRef<HTMLButtonElement | null>(null);
  useEffect(() => stay.current?.focus(), []);
  return (
    <div
      className="lcr-leave-confirm"
      role="alertdialog"
      aria-label="Unsaved changes"
      aria-describedby="lcr-leave-confirm-text"
      onKeyDown={(event) => {
        if (event.key !== "Escape") return;
        event.preventDefault();
        event.stopPropagation();
        onStay();
      }}
    >
      <p id="lcr-leave-confirm-text">Leave this conversation and discard unsaved changes?</p>
      <button type="button" className="lcr-small-button" ref={stay} onClick={onStay}>
        Stay
      </button>
      <button type="button" className="lcr-small-button lcr-ghost" onClick={onLeave}>
        Discard and leave
      </button>
    </div>
  );
}
